import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch } from 'react-redux';
import MatchList from "../Match/components/MatchList";
import MyPlayers from "../Team/components/MyPlayers";
import PrevArrow from "../Components/PrevArrow";
import NextArrow from "../Components/NextArrow";
import { loaderStateFalse, loaderStateTrue } from "../../slices/mainSlice";
import { getMatchListApi } from "../Match/MatchController";
import { getPlayerListApi } from "../Team/TeamController";

const CoachDashboard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { language } = useSelector((state) => state.language);
  const { userDetails, token, userType } = useSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState("tab1");
  const [matchList, setMatchList] = useState([]);
  const [playerList, setPlayerList] = useState([]);
  const tabs = [
    { id: "tab1", label: t('allGame') },
    { id: "tab2", label: t('liveGame') },
    { id: "tab3", label: t('preMatch') },
  ];

  useEffect(() => {
    // dispatch(setActiveLink("dashboard"))
  }, [])

  useEffect(() => {
    getMatchList();
    getPlayerList();
  }, []);

  const getMatchList = () => {
    try {
      dispatch(loaderStateTrue());
      getMatchListApi()
        .then((response) => {
          let responseData = response.data?.result || [];
          console.log("responseDataresponseDataresponseData", responseData)
          setMatchList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };
  const getPlayerList = () => {
    try {
      dispatch(loaderStateTrue());
      getPlayerListApi()
        .then((response) => {
          let responseData = response.data || [];
          setPlayerList(responseData);
          dispatch(loaderStateFalse());
        })
        .catch((error) => {
          console.log(error);
          dispatch(loaderStateFalse());
        });
    } catch (error) {
      console.log(error);
      dispatch(loaderStateFalse());
    }
  };

  // Table list
  const matches = [
    {
      time: "12:30",
      date: "26 Aug",
      teams: [
        { name: "Paris Saint-Germain", logo: require("../../assets/images/clubs/paris.png") },
        { name: "Stade Brestois 29", logo: require("../../assets/images/clubs/sb29.png") }
      ],
      score: [2, 1],
      points: 2,
      chartIcon: "../../assets/images/icons/bar-chart.svg",
      rank: 24
    },
    {
      time: "14:00",
      date: "27 Aug",
      teams: [
        { name: "Racing Club de Lens", logo: require("../../assets/images/clubs/rcl.png") },
        { name: "Olympique Lyonnais", logo: require("../../assets/images/clubs/rfef.png") }
      ],
      score: [3, 1],
      points: 10,
      chartIcon: "../../assets/images/icons/bar-chart.svg",
      rank: 22
    }
  ];

  const playersData = [
    {
      name: 'Kamory Doumbia',
      image: 'assets/images/players-list/1.png',
      rating: 4.5
    },
    {
      name: 'John Doe',
      image: 'assets/images/players-list/2.png',
      rating: 4.2
    },
    {
      name: 'Jane Smith',
      image: 'assets/images/players-list/3.png',
      rating: 4.8
    },
    {
      name: 'Michael Brown',
      image: 'assets/images/players-list/4.png',
      rating: 4.1
    },
    {
      name: 'David Johnson',
      image: 'assets/images/players-list/5.png',
      rating: 3.9
    },
    {
      name: 'Samuel Adams',
      image: 'assets/images/players-list/6.png',
      rating: 4.7
    }
  ];

  return (
    <>
      {userDetails.team ? (
        <main className="main p-4 relative">
          <div className="flex flex-col">
            <div className="flex flex-wrap items-start gap-y-6 -mx-2">
              <div className="lg:w-4/6 w-full px-2">
                <div className="space-y-5">
                  <div className="relative text-white">
                    <div className="rounded-xl absolute inset-0 bg-gradient-to-b from-[#1B3594] to-[#1A215A] overflow-hidden">
                    </div>
                    <div className="relative bg-[url('../public/assets/images/club-bg.png')] bg-cover bg-no-repeat bg-center h-full">
                      <div className="flex max-sm:flex-wrap gap-y-3">
                        <div className="p-5 flex flex-col items-start justify-between [&_h1_strong]:text-primary-500 space-y-3 md:w-1/2 [&_strong]:text-primary-500">
                          <div className="flex max-sm:flex-wrap items-center gap-3">
                            <ul className="flex -space-x-4 rtl:space-x-reverse">
                              <li className="p-1.5 size-14 flex justify-center items-center border-4 border-[#1B3594] rounded-full bg-white">
                                <img className="size-7 object-contain dark:border-gray-800" src={require("../../assets/images/clubs/paris.png")} alt="" />
                              </li>
                              <li className="p-1.5 size-14 flex justify-center items-center border-4 border-[#1B3594] rounded-full bg-white">
                                <img className="size-7 object-contain dark:border-gray-800" src={require("../../assets/images/clubs/sb29.png")} alt="" />
                              </li>
                            </ul>
                            <div>
                              <h3 className="text-base font-bold uppercase">Paris Saint-Germain FC Stade Brestois 29</h3>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <img src={require("../../assets/images/league1m.png")} alt="" />
                            <h4 className="lg:text-2xl md:text-xl text-lg font-bold uppercase">Paris Saint-Germain FC</h4>
                            <ul className="flex flex-wrap gap-1">
                              <li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
                                <span className="opacity-50">1 x</span> 5.50
                              </li>
                              <li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
                                <span className="opacity-50">x</span> 3.25
                              </li>
                              <li className="px-3 py-1 border border-white/30 text-xs rounded-full font-secondary font-bold">
                                <span className="opacity-50">2 x</span> 2.13
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="lg:-mt-4 text-center">
                          <img src={require("../../assets/images/france-teams.png")} alt="" className="w-full inline-block" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <h3 className="xl:text-2xl text-xl font-extrabold uppercase">{t('league1Ranking')}</h3>
                    <select className="form-select font-bold !max-w-[200px]">
                      <option value="">{t('season')} 2025/25</option>
                      <option value="">{t('season')} 2025/25</option>
                    </select>
                    <button className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</button>
                  </div>

                  <div className="">
                    <ul className="mb-3 nav nav-tabs flex border-b light-border [&>*]:flex-1 [&>*]:nav-item [&>*]:inline-flex [&>*]:justify-center [&>*]:items-center [&>*]:gap-1">
                      {tabs.map((tab) => (
                        <li
                          key={tab.id}
                          className={`nav-item ${activeTab === tab.id
                            ? "active"
                            : ""
                            }`}
                          onClick={() => setActiveTab(tab.id)}
                        >
                          <button>{tab.label}</button>
                        </li>
                      ))}
                    </ul>
                    <div className="tab-content space-y-4">
                      {activeTab === "tab1" && (
                        <div className="tab-pane">
                          <MatchList matchList={matchList} />
                        </div>
                      )}
                      {activeTab === "tab2" && (
                        <MatchList matchList={matchList} />
                      )}
                      {activeTab === "tab3" && (
                        <MatchList matchList={matchList} />
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="lg:w-2/6 w-full px-2 space-y-6 sticky top-20">
                <div className="p-4 rounded-xl bg-gray-100 relative overflow-hidden">
                  <div className="w-32 h-2 bg-white absolute top-9 -right-8 rotate-45"></div>
                  <div className="flex items-center gap-3">
                    <div className="w-48">
                      <img src="/assets/images/clubs/paris.png" alt="" />
                    </div>
                    <div className="pr-10">
                      <div className="font-bold uppercase text-gray-400">My Team</div>
                      <h4 className="text-3xl font-extrabold uppercase leading-none">Paris<br /><span className="text-gray-400">Saint-Germain</span></h4>
                    </div>
                  </div>
                </div>
                <MyPlayers playerList={playerList} />
              </div>
            </div>
          </div>
        </main>) : (
        <>
          <div className="space-y-5">
            <div className="relative">
              <div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
                <div className="absolute -skew-x-[20deg] w-[4vw] top-0 -left-12 bottom-0 bg-[#3D54AC]"></div>
                <div className="absolute -skew-x-[20deg] w-[18vw] top-0 -right-12 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/10"></div>
              </div>
              <div className="relative bg-cover bg-no-repeat bg-center h-full">
                <div className="flex lg:justify-center justify-center max-sm:flex-wrap gap-y-3 w-full">
                  <div className="flex-none max-sm:w-1/2 max-lg:w-1/3 lg:-mt-4 relative">
                    <img src="assets/images/teams.png" alt="" className="max-w-full lg:max-h-[276px] inline-block" />
                  </div>
                </div>
                <div className="absolute left-0 bottom-0 right-0 p-4 flex justify-between items-center gap-6 bg-gradient-to-t from-[#3D54AC] rounded-b-xl overflow-hidden">
                  <div className="">
                    <div className="space-y-2">
                      <h4 className="lg:text-2xl md:text-xl text-lg font-black leading-none uppercase text-white">{t('createTeam')}</h4>
                    </div>
                  </div>
                  <div className="">
                    <button className="btn btn-primary text-nowrap ml-auto" onClick={() => navigate(`/${language}/create-team`)}>{t('seeAll')}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CoachDashboard;
